import { SERVICE_WORKER_REGISTRATION_LOG_EVENT_CHANNEL_NAME, SERVICE_WORKER_REGISTRATION_NEWVERSION_EVENT_CHANNEL_NAME } from "./ServiceWorker/constants";
import { IServiceWorkerRegistrationLogEvent, IServiceWorkerRegistrationNewAppVersionAvailableEvent } from "./ServiceWorker/types";


const isProduction = process.env.NODE_ENV === 'production';

const logBroadcastChannel = new BroadcastChannel(SERVICE_WORKER_REGISTRATION_LOG_EVENT_CHANNEL_NAME);
const newVersionBroadcastChannel = new BroadcastChannel(SERVICE_WORKER_REGISTRATION_NEWVERSION_EVENT_CHANNEL_NAME);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

function log(type: "info" | "warning" | "error", message: string, data?: any) {
  const logMessage: IServiceWorkerRegistrationLogEvent = { type, message, data };

  if (type === "error")
    console.error(logMessage);
  else
    console.dir(logMessage);

  logBroadcastChannel.postMessage(logMessage);
}

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config?: Config) {

  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebook/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = isProduction ? `${process.env.PUBLIC_URL}/service-worker.js` : `${process.env.PUBLIC_URL}/service-worker-dev.js?webpack-dev-server-hot=false&webpack-dev-server-live-reload=false`;

      if (isLocalhost) {
        // This is running on localhost. Let's check if a service worker still exists or not.
        checkValidServiceWorker(swUrl, config);
      } else {
        // Is not localhost. Just register service worker
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl: string, config?: Config) {

  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {

      registration.onupdatefound = () => {

        const installingWorker = registration.installing;

        if (installingWorker === null) {
          return;
        }

        installingWorker.onstatechange = () => {

          if (installingWorker.state === 'installed') {

            log('info', `Loaded Service Worker: ${navigator.serviceWorker.controller?.scriptURL}`);

            if (navigator.serviceWorker.controller) {

              // At this point, the updated precached content has been fetched,
              // but the previous service worker will still serve the older
              // content until all client tabs are closed.
              log("info", 'New content available');

              // Execute callback
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }

              const logMessage: IServiceWorkerRegistrationNewAppVersionAvailableEvent = { };
              newVersionBroadcastChannel.postMessage(logMessage); 

            } else {

              // At this point, everything has been precached.
              log("info", 'Content is cached for offline use.');

              // Execute callback
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }

            }

          }

        };
      };

    })
    .catch((error) => {
      log("error", 'Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl: string, config?: Config) {

  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      // Ensure service worker exists, and that we really are getting a JS file.
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {

        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });

      } else {

        // Service worker found. Proceed as normal.
        registerValidSW(swUrl, config);

      }

    })
    .catch(() => {
      log('info', 'No internet connection found. App is running in offline mode.')
    });
}

export function unregister() {

  if ('serviceWorker' in navigator) {

    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        log('error', error.message,error)
      });

  }

}